import { mediaQuery } from '~/js/helpers';

const gsap = window.gsap;
const SplitText = window.SplitText;

document.addEventListener('DOMContentLoaded', () => {
	const sections = document.querySelectorAll('section.intro-block-animated');
	const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
	sections.forEach((section) => {
		const title = section.querySelector('[data-split]');

		if (prefersReduced) {
			title.style.opacity = '1';
			return;
		}

		let end = section.getBoundingClientRect().height + 100;
		if (mediaQuery('lg')) {
			end += 100;
		}
		document.fonts.ready.then(() => {
			const split = new SplitText(title, {
				type: 'words',
			});
			title.style.opacity = '1';

			const tl = gsap
				.timeline({
					scrollTrigger: {
						trigger: section,
						start: 'top bottom-=200',
						end: '+=' + end + 'px',
						scrub: 0.5,
					},
				})
				.set(
					split.words,
					{
						opacity: 1,
						stagger: 0.1,
					},
					0.1
				);
		});
	});
});
